import { render, staticRenderFns } from "./IncomeAndExpenses.vue?vue&type=template&id=03f3a517&scoped=true&"
import script from "./IncomeAndExpenses.vue?vue&type=script&lang=ts&"
export * from "./IncomeAndExpenses.vue?vue&type=script&lang=ts&"
import style0 from "./IncomeAndExpenses.vue?vue&type=style&index=0&id=03f3a517&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f3a517",
  null
  
)

export default component.exports